import * as Yup from 'yup';
import phoneNumber from '../../schemas/phoneNumber';

export default Yup.object().shape({
  name: Yup.string()
    .min(2, 'Nome troppo corto'),
  phoneNumber: Yup.string()
    .required('Il recapito telefonico è necessario')
    .concat(phoneNumber),
  email: Yup.string()
    .email('Formato email non valido'),
});
